import { Component, Input } from '@angular/core';
import { ContractStatus } from 'src/app/models/billingContractAndOptions';
import { contractStatusDropdownOptions } from 'src/app/models/billingContractAndOptions';
import { MatChipSet, MatChip } from '@angular/material/chips';
import { NgClass } from '@angular/common';

@Component({
	selector: 'app-billing-status',
	templateUrl: './billing-status.component.html',
	styleUrls: ['./billing-status.component.scss'],
	imports: [MatChipSet, MatChip, NgClass],
})
export class BillingStatusComponent {
	@Input() status!: ContractStatus;

	constructor() {}

	getStatusName(status: ContractStatus): string {
		const value = contractStatusDropdownOptions.find(
			(statusLabel) => statusLabel.value === status
		);
		if (!value) {
			return 'unknown';
		}
		return value.label;
	}

	getChipStyling(status: ContractStatus): string {
		switch (status) {
			case 'autoRenewed':
				return 'status-chip-active';
			case 'upcoming':
				return 'status-chip-upcoming';
			case 'manuallyEnded':
				return 'status-chip-manually-ended';
			case 'completed':
				return 'status-chip-completed';
			default:
				return 'status-chip-active';
		}
	}
}
